import React, {Component} from 'react'
import {connect} from 'react-redux'

import {setWhiteBanner, setTitle} from 'common/redux/root'
import SettlementProviderSelection from "manager/views/components/Settlement/SettlementProviderSelection"
import {fetchReferral} from "manager/redux/referral"

/**
 * Top-level view for settlement provider concerns in the context of some referral.
 */
class SettlementProviderView extends Component {

  componentWillMount() {
    const { dispatch } = this.props
    dispatch(setWhiteBanner(true))
    dispatch(fetchReferral(this.props.params.hash, true)).then(
      response => {
        dispatch(setTitle("Title & Escrow", response.referral.name))
      }
    )
  }

  render() {
    const { referral } = this.props
    return (
      referral ? (
        <SettlementProviderSelection />
      ) : null
    )
  }
}

export default connect((state) => ({ ...state.referral}))(SettlementProviderView)
